import PresetList from "ui/dealer-focus/preset-list";
import AlertCamera from "./alertCamera";
import AlertVideo from "./alertVideo";
import { useContext, useEffect, useState } from "react";
import { getCameraById } from "pages/dashboard/cases/service";
import { useCommonService } from "pages/service";
import { StreamingCameraType } from "lib/types";
import { AuthContext } from "context/AuthContext";
import { SignalContext } from "context/SignalContext";
export default function AlertDetail({
  alert,
  onAlertStatusChange,
  activeCase,
}) {
  const { getCredentials } = useCommonService();
  const { user } = useContext(AuthContext);
  const { sessionId } = useContext(SignalContext);
  const [streamingCamera, setStreamingCamera] = useState(null);
  const [showPtzCapabilites, setShowPtzCapabilites] = useState(false);
  useEffect(() => {
    if (!alert) return;
    setShowPtzCapabilites(false);
    getCameraById(alert.camera.id).then(async (data) => {
      const dataCamera = data.data;
      setShowPtzCapabilites(dataCamera.data.capabilities.ptz);
      const dataCredentials = await getCredentials([+dataCamera.data.nvrId]);
      const streamingCamera: StreamingCameraType = Object.assign(
        {},
        dataCamera.data,
        {
          orgId: dataCamera.data.orgId,
          nvrId: dataCamera.data.nvrId,
          devId: dataCamera.data.devId,
          type: dataCamera.data.type,
          cameraId: alert.camera.id,
          cameraName: dataCamera.data.name,
          token: user.token,
          sessionId: sessionId,
          cameraMac: dataCamera.data.macAddress,
          remoteIndex: dataCamera.data.remoteIndex,
          streamId: "1",
          status: dataCamera.data.status,
          rtcToken: dataCredentials?.at(0)?.token,
          turn: dataCredentials?.at(0)?.turn,
          siteId: dataCamera.data.siteId,
          siteName: dataCamera.data.siteName,
          capabilities: dataCamera.data.capabilities,
          nvr: dataCamera.data.nvr,
          videoInfo: {
            width:
              dataCamera.data.subStream?.resolution?.width ||
              dataCamera.data.mainStream?.resolution?.width,
            height:
              dataCamera.data.subStream?.resolution?.height ||
              dataCamera.data.mainStream?.resolution?.height,
            fps:
              dataCamera.data.subStream?.frameRate ||
              dataCamera.data.mainStream?.frameRate,
          },
        },
      );
      console.log("stateStreamingCamera setStreamId", dataCamera);
      setStreamingCamera(streamingCamera);
    });
  }, [alert.camera.id]);
  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <AlertVideo
        activeAlert={alert}
        onAlertStatusChange={onAlertStatusChange}
        activeCase={activeCase}
      />
      <AlertCamera
        activeAlert={alert}
        streamingCamera={streamingCamera}
        showPtzCapabilites={showPtzCapabilites}
      />
      <div
        style={{
          position: "relative",
          height: "120px",
          alignContent: "center",
        }}
      >
        {streamingCamera?.capabilities?.ptz ? (
          <PresetList
            row={1}
            pageSize={3}
            col={3}
            selectedCamera={streamingCamera}
          />
        ) : (
          <div className="flex items-center justify-center gap-1 pt-2 pb-2">
            <div style={{ textAlign: "center" }}>No preset available</div>
          </div>
        )}
      </div>
    </div>
  );
}
